import React, { memo } from 'react';
import Grid, { Grid2Props } from '@mui/material/Unstable_Grid2';

export const GMGrid: React.FC<Grid2Props> = memo((props) => {
    return <Grid {...props} />;
});